import ApiService from '../api.service';

const SchoolClasses = {
  show: (params) => ApiService.get(`/api/v2/teachers/me/school_classes/${params.schoolClassId}`),
};

export default SchoolClasses;
